"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {hasClass, on, findIn, closest, findAllIn, addClass, removeClass} from '@elements/dom-utils';

let lastOffset = 0;

export function init() {
    onFind('.js-center-active-tab', function (element) {
        let activeTab = findIn('.active', element);
        let navTab = findAllIn('.nav-item', element);

        calcCenter(activeTab);

        navTab.forEach(function (item) {
            on('click', function (evt) {
                if (!hasClass('is-centered', evt.target)) {
                    calcCenter(evt.target);
                }
            }, item);
        });

    });


    function calcCenter(activeItem) {
        let navList = closest('ul', activeItem);
        let navItems = findAllIn('.nav-item', navList)

        let index;
        for (index = 0; index < navItems.length; index++) {
            if (navItems[index] === activeItem.parentElement) {
                break;
            }
        }

        navItems.forEach(function (navItem) {
            removeClass('is-centered', navItem);
        });

        if (activeItem) {
            let childPos = activeItem.offsetLeft;
            let parentScroll = activeItem.parentElement.scrollLeft;
            let offset = childPos + parentScroll - window.innerWidth / 2 + activeItem.offsetWidth / 2 ;

            if (index === 0) {
                activeItem.parentElement.parentElement.scrollLeft = 0;
            } else {
                activeItem.parentElement.parentElement.scrollLeft = offset;
            }

            // if (index === 0) {
            //     if (lastOffset>offset){
            //         activeItem.parentElement.parentElement.scrollBy({
            //             right: 0,
            //             behavior: 'smooth'
            //         });
            //     }else{
            //         activeItem.parentElement.parentElement.scrollBy({
            //             left: 0,
            //             behavior: 'smooth'
            //         });
            //     }
            // } else {
            //     // activeItem.parentElement.parentElement.scrollLeft = offset;
            //     if (lastOffset>offset){
            //         activeItem.parentElement.parentElement.scrollBy({
            //             right: offset,
            //             top: 0,
            //             behavior: 'smooth'
            //         })
            //     }else{
            //         activeItem.parentElement.parentElement.scrollBy({
            //             left: offset,
            //             top: 0,
            //             behavior: 'smooth'
            //         })
            //     }
            //
            // }

            addClass('is-centered', activeItem.parentElement);
            lastOffset = offset;

        }
    }

}